// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__BHVNg","footer":"ModalError_footer__3qJqL"};